import { render, staticRenderFns } from "./emergencyContact.vue?vue&type=template&id=51a4093c&scoped=true"
import script from "./emergencyContact.vue?vue&type=script&lang=js"
export * from "./emergencyContact.vue?vue&type=script&lang=js"
import style0 from "./emergencyContact.vue?vue&type=style&index=0&id=51a4093c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4093c",
  null
  
)

export default component.exports